import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../../../state/reducers';
import { clearSocialPublishing } from '../../../../../state/publishAssets';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';

class SocialDialog extends React.Component<IProps> {
  handleDialogExited = () => {
    const {
      onDialogExited,
      clearSocialPublishingConnect,
    } = this.props;

    clearSocialPublishingConnect();
    if (typeof onDialogExited === 'function') {
      onDialogExited();
    }
  };

  render() {
    const {
      children,
      settingType,
      isOpen,
      socialPublishing: {
        settings: publishSettings,
      },
      onDialogEntered,
    } = this.props;

    if (publishSettings === null || publishSettings.type !== settingType) {
      return null;
    }

    return (
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth="md"
        TransitionProps={{
          onEntered: onDialogEntered,
          onExited: this.handleDialogExited,
        }}
      >
        {children}
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
  isOpen: state.publishSelectedAssetsToEndPoints.isSocialPublishDialogOpen,
});

const mapDispatchToProps: IDispatchProps = {
  clearSocialPublishingConnect: clearSocialPublishing,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialDialog);
